import { urlWithParams } from '@marketplace-web/shared/utils'

export const MEMBER_PROFILE_URL = (id: string | number, closetPromotionPrecheckout?: boolean) =>
  urlWithParams(`/member/${id}`, { cp_precheckout: closetPromotionPrecheckout })
export const ITEM_UPLOAD_URL = '/items/new'
export const CREATE_BUNDLE_URL = (id: string | number): string => `/member/${id}/bundles/new`
export const MARK_AS_SOLD_URL = (transactionId: number): string =>
  ` /transactions/${transactionId}/mark_as_sold/new?act_as=sold`
export const ROOT_URL = '/'
export const TRANSACTION_FAQ_ENTRY_URL = (transactionId: number) =>
  `/help/for_transaction/${transactionId}`
export const SIGNUP_URL = '/member/signup/select_type'
export const NEW_ADMIN_ALERT_URL = '/admin_alert/new'
export const HELP_FAQ_ENTRIES_URL = '/help'
export const ESCROW_HELP_URL = '/help/1417'
export const ORDER_DETAILS_URL = (transactionId: number) => `/order_details/${transactionId}`
